import { LoadState } from "../../constants/enums";
import { IIntents } from "./Intents.types";


export const initialIntents: IIntents = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};





